import { store } from '@/stores'
import {
  GOODS_SET_COUNT,
  GOODS_INCREASE,
  GOODS_DECREASE,
} from '@/action-types/goods'

export const setGoodTotal = (total: any) => {
  store.dispatch({ type: GOODS_SET_COUNT, count: total })
}
export const goodTotalIncrease = () => {
  store.dispatch({
    type: GOODS_INCREASE,
  })
}
export const goodTotalDecrease = () => {
  store.dispatch({
    type: GOODS_DECREASE,
  })
}
